import { useScreen } from "./app/store.ts";
import { Lobby } from "./screens/Lobby.tsx";
import { Match } from "./screens/Match.tsx";
import { Results } from "./screens/Results.tsx";

export function App() {
  const screen = useScreen();
  if (screen.name === "match")
    return (
      <Match key={screen.session.roomId} session={screen.session} nickname={screen.nickname} />
    );
  if (screen.name === "results")
    return <Results client={screen.client} nickname={screen.nickname} />;
  return <Lobby notice={screen.notice} />;
}
